import {behavior_config, server_config} from "../framework/src/engine/madnes/madnes_variables";

export default function ServerConfig() {
	/** @type {Object} */
	this._serverConfig;
};

ServerConfig.prototype.lastRoundEnded = function() {
    return this._serverConfig["last_round"]["ended"];
};

/**
 * @param {Object} res
 * @returns {undefined}
 */
ServerConfig.prototype.setServerConfig = function(res) {
    this._serverConfig = res;
    this._serverConfig.behavior = behavior_config;
};

/**
 * @returns {Array}
 */
ServerConfig.prototype.getPositions = function() {
    return this._serverConfig["matrix"]["position"];
};

ServerConfig.prototype.getSymbols = function() {
    return this._serverConfig["logic"]["symbols"];
};

ServerConfig.prototype.getBetSet = function() {
    return this._serverConfig["logic"]["bet_set"];
};

/**
 * @returns {Array}
 */
ServerConfig.prototype.getReels = function() {
    return this._serverConfig["logic"]["reels"];
};

ServerConfig.prototype.getReelMatrix = function() {
    return this._serverConfig["matrix"]["reelMatrix"];
};

ServerConfig.prototype.getFailResult = function() {
    return this._serverConfig["logic"]["failResult"];
};

ServerConfig.prototype.getSpinDuration = function() {
    return this._serverConfig["behavior"]["reel"]["spin"]["duration"];
};

/**
 * @public
 * @returns {number}
 */
ServerConfig.prototype.getSpinCommonSpeed = function() {
    return this._serverConfig["behavior"]["reel"]["spin"]["commonSpeed"];
};

/**
 * @public
 * @returns {number}
 */
ServerConfig.prototype.getSpinScatterSpeed = function() {
    return this._serverConfig["behavior"]["reel"]["spin"]["scatterSpeed"] * 1;
};

ServerConfig.prototype.getAccHeight = function() {
    return this._serverConfig["behavior"]["reel"]["acceleration"]["accelerationHeight"];
};

ServerConfig.prototype.getAccMoveBackTime = function() {
    return this._serverConfig["behavior"]["reel"]["acceleration"]["moveBackTime"];
};

ServerConfig.prototype.getAccMoveTime = function() {
    return this._serverConfig["behavior"]["reel"]["acceleration"]["moveTime"];
};

ServerConfig.prototype.getBrakeHeight = function() {
    return this._serverConfig["behavior"]["reel"]["brake"]["brakeHeight"];
};

ServerConfig.prototype.getBrakeMoveBackTime = function() {
    return this._serverConfig["behavior"]["reel"]["brake"]["moveBackTime"];
};

ServerConfig.prototype.getBrakeMoveTime = function() {
    return this._serverConfig["behavior"]["reel"]["brake"]["moveTime"];
};

ServerConfig.prototype.getMinBigWinFactor = function() {
    return this._serverConfig["behavior"]["reel"]["minBigWinFactor"];
};

ServerConfig.prototype.getMinMegaWinFactor = function() {
    return this._serverConfig["behavior"]["reel"]["minMegaWinFactor"];
};

ServerConfig.prototype.getMinSuperMegaWinFactor = function() {
    return this._serverConfig["behavior"]["reel"]["minSuperMegaWinFactor"];
};

ServerConfig.prototype.getReelSpinDuration = function() {
    return this._serverConfig["behavior"]["reel"]["spin"]["duration"];
};

/**
 * @public
 * @returns {number}
 */
ServerConfig.prototype.getDelayBetweenReelStops = function() {

    if(typeof this._serverConfig["behavior"]["reel"]["spin"]["delayBetweenReelStops"] === 'undefined') {
        return 0;
    }

    return this._serverConfig["behavior"]["reel"]["spin"]["delayBetweenReelStops"] * 1;
};

/**
 * @returns {number}
 */
ServerConfig.prototype.getScatterDelay = function() {
    return this._serverConfig["behavior"]["reel"]["spin"]["scatterDelay"] * 1;
};

/**
 * @returns {number}
 */
ServerConfig.prototype.getScatterDuration = function() {
    return this._serverConfig["behavior"]["reel"]["spin"]["scatterDuration"] * 1;
};

ServerConfig.prototype.getVolumeBigWin = function() {
    return server_config["behavior"]["sound"]["volume"]["bigWin"];
};

ServerConfig.prototype.getVolumeButtonEffect = function() {
    return server_config["behavior"]["sound"]["volume"]["buttonEffect"];
};

ServerConfig.prototype.getVolumeSpin = function() {
    return server_config["behavior"]["sound"]["volume"]["spin"];
};

ServerConfig.prototype.getVolumeStartReel = function() {
    return server_config["behavior"]["sound"]["volume"]["startReel"];
};

ServerConfig.prototype.getVolumeStopReel = function() {
    return server_config["behavior"]["sound"]["volume"]["stopReel"];
};

ServerConfig.prototype.getVolumeWinAnim = function() {
    return server_config["behavior"]["sound"]["volume"]["winAnim"];
};

ServerConfig.prototype.getVolumeWinCounter = function() {
    return server_config["behavior"]["sound"]["volume"]["winCounter"];
};

ServerConfig.prototype.getVolumeBackground = function() {
    return server_config["behavior"]["sound"]["background"]["background"];
};

ServerConfig.prototype.getVolumeFSBackground = function() {
    return server_config["behavior"]["sound"]["background"]["freeSpinsBackground"];
};

ServerConfig.prototype.getVolumeBonusBackground = function() {
    return server_config["behavior"]["sound"]["background"]["bonusGameBackground"];
};

ServerConfig.prototype.getVolumeMiscSound1 = function() {
    return server_config["behavior"]["sound"]["miscSounds"]["miscSounds1"];
};

ServerConfig.prototype.getVolumeMiscSound2 = function() {
    return server_config["behavior"]["sound"]["miscSounds"]["miscSounds2"];
};

ServerConfig.prototype.getVolumeMiscSound3 = function() {
    return server_config["behavior"]["sound"]["miscSounds"]["miscSounds3"];
};

ServerConfig.prototype.getVolumeMiscSound4 = function() {
    return server_config["behavior"]["sound"]["miscSounds"]["miscSounds4"];
};

ServerConfig.prototype.getVolumeMiscSound5 = function() {
    return server_config["behavior"]["sound"]["miscSounds"]["miscSounds5"];
};